import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { redirectsAPI, Redirect } from '../services/redirectsApi';

export const useRedirects = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [redirects, setRedirects] = useState<Redirect[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch redirects from API
  useEffect(() => {
    const fetchRedirects = async () => {
      try {
        const data = await redirectsAPI.getRedirects();
        setRedirects(data);
      } catch (error) {
        console.error('Failed to fetch redirects:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRedirects();
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Find active redirects that match the current path
    const activeRedirects = redirects.filter(
      redirect => redirect.status === 'active' && redirect.oldUrl === currentPath
    );

    if (activeRedirects.length > 0) {
      const redirect = activeRedirects[0];
      
      // Log the redirect for analytics (in a real app, you'd send this to your analytics service)
      console.log(`Redirecting from ${redirect.oldUrl} to ${redirect.newUrl} (${redirect.redirectType})`);
      
      // Perform the redirect
      navigate(redirect.newUrl, { replace: true });
    }
  }, [location.pathname, redirects, navigate]);

  return {
    redirects,
    isLoading,
    addRedirect: redirectsAPI.createRedirect,
    updateRedirect: redirectsAPI.updateRedirect,
    deleteRedirect: redirectsAPI.deleteRedirect,
    toggleStatus: redirectsAPI.toggleRedirectStatus,
  };
}; 